import { useContext } from 'react';
import styled from '@emotion/styled';
import { ChartLegend } from '@trinity/chat-components/components/Widgets/Charts/Legend.js';
import { BasicMarkdown } from '../Markdown/Markdown';
import { ChartViewContainer } from './Chat.Chat.ViewContainer';
import { ChartInfoContext, ChartTypeContext } from './context';
import { useRenderResponseChart, useResponseChartLegend } from './Message.Response.Chart.hooks';


export const ChartResponse = () => {
  const legend = useResponseChartLegend();
  const renderChart = useRenderResponseChart({ legend, unitInfo: null });
  const [chartType] = useContext(ChartTypeContext);
  const [chart] = useContext(ChartInfoContext);

  return (
    <div>
      {chart.chart &&
        <BasicMarkdown>{chart.chart.response}</BasicMarkdown>
      }

      <Chart>
        <ChartViewContainer
          renderChart={() => renderChart(chartType)}
          chartType={chartType} />
        {chart.chart.chart && (
          <>
            {chart.footer && chart.footer.length > 0 && (
              <Footer>{chart.footer[0]}</Footer>
            )}
            {legend.length > 0 && <ChartLegend legend={legend} />}
          </>
        )}
      </Chart>
    </div>
  );
};

const Chart = styled.div`
  border: 1px solid var(--gray-l);
  border-radius: 15px;
  padding: 12px;
  margin-top: 10px;
  background-color: white;
`;

const Footer = styled.div`
  font-family: var(--font-semibold);
  font-size: 14px;
  margin-bottom: 10px;
`;

